import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'device-groups',
    templateUrl: './device-groups.component.html',
    styleUrls: ['./device-groups.component.scss']
})

export class DeviceGroupsComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
    }
}
